module.exports = __webpack_public_path__ + "img/美辰星耀.b6e0da0.png";